import { combineReducers } from "redux";
import {AuthReducer} from "./AuthReducer";
import { ACTIONTYPES } from "../Actions/Types";
// Combine all reducers.
const appReducer = combineReducers({
  auth: AuthReducer
});
const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === ACTIONTYPES.LOGOUT_USER) state = undefined;

  return appReducer(state, action);
};
export default rootReducer;
